import {
	Component,
	Input,
	OnInit,
	Output,
	ViewChild,
	EventEmitter,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Table } from 'primeng/table';
import { ColumnTypeEnum } from '../../enumerations/JabilEnumeration';
import { IColumn } from '../../interfaces/IColumn';
import { IPagedResult } from '../../interfaces/IPagedResult';
import { TransactionResult } from '../../services/interfaces/transaction-result';
import { NotificationService } from '../../services/notification/notification.service';
import { TranslateApplicationService } from '../../translate/translate-application-service';
import {
	IActionCustomData,
	ICustomAction,
} from '../../interfaces/ICustomAction';
import { IDefaultFilter } from '../../interfaces/IDefaultFilter';
import { JabilTableService } from '../../../main/content/sections/services/jabil-table-service';
import { Paginator } from 'primeng/paginator';
import * as _ from 'lodash';

@Component({
	selector: 'jabil-table',
	templateUrl: './jabil-table.component.html',
	styleUrls: ['./jabil-table.component.scss'],
})
export class JabilTableComponent implements OnInit {
	@Input() protected columns: Array<IColumn>;
	@Input() protected station: string;
	@Input() protected title: string;
	@Input() protected showFilterByColumn = false;
  @Input() protected hideButtonAdd: boolean = false;
  @Input() protected nameButtonAdd: string = "";
  @Input() protected hideButtonEdit: boolean = false;
  @Input() protected nameButtonEdit: string = "";
  @Input() protected hideButtonExport: boolean = false;
  @Input() protected nameButtonExport: string = "";
  @Input() protected hideButtonRefresh: boolean = false;
  @Input() protected hideButtonFilter: boolean = false;
	@Input() protected controller: string = '';
	@Input() protected endPoint: string = '';
	@Input() protected customAction: Array<ICustomAction>;
	@Input() protected defaultFilter: boolean = false;
  @Input() protected service: string = '';
  @Input() protected filterByEnter: boolean = false;
  @Input() protected isProjected: boolean = false;
  @Input() protected disableInit: boolean = false;

	@Output() protected buttonAdd = new EventEmitter<any>();
	@Output() protected buttonEdit = new EventEmitter<any>();
  @Output() protected customActionEvent = new EventEmitter<any>();
  @Output() protected onChangeData = new EventEmitter<any>();
  @ViewChild('jabilTable') protected table: Table;
  @ViewChild('jabilPaginator') protected paginator: Paginator;

	protected selectedData: any = null;
	protected pagedResult: IPagedResult;
	protected data: any[];
	protected pageNumber: number = 0;
	protected pageCount: number = 0;
	protected pageSize: number = 10;
	protected loading: boolean = false;
	protected rowCount: number = 0;
	protected myPaginationString: string = '';
	protected predicate: string = 'p => true';
	protected sort: string = 'order => order.';
	protected sortDirection: string = 'Ascending';
	protected clickCheckBox: boolean = false;
	protected clickDatePicker: boolean = false;
	protected indeterminate: boolean = true;
	protected formFilter: FormGroup;
	protected orderTypeList: Array<any> = [
		{ name: 'ASCENDING', value: 'Ascending' },
		{ name: 'DESCENDING', value: 'Descending' },
	];
	protected propertyReferences: string = '';
  protected defaultFilterList: Array<IDefaultFilter> = [];
  protected isChecked: boolean;

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateApplicationService,
		private jabilTableService: JabilTableService,
		private formBuilder: FormBuilder,
	) {
		this.formFilter = this.formBuilder.group({
			order: [''],
			orderType: [''],
		});
	}

  ngOnInit(): void {
		  this.setInitial();
	}

	protected setInitial(): void {
    let principalColumn: IColumn = this.columns.find(
      (p) => p.principal,
    );

    if (principalColumn.reference) {
      if (principalColumn.propertyInternalName)
        this.sort += principalColumn.reference + "." + principalColumn.propertyInternalName;
      else
        this.sort += principalColumn.name;
    }
    else
      this.sort += principalColumn.name;

    this.formFilter.controls.order.setValue(principalColumn.name);
		this.formFilter.controls.orderType.setValue(this.sortDirection);

    let referenceExist: Array<string> = [];

		this.columns.forEach((column) => {
      if (column.reference) {
        if (referenceExist.find(p => p == column.reference) == null) {

          if (this.propertyReferences.length == 0)
            this.propertyReferences +=
              'prop => prop.' + column.reference;
          else
            this.propertyReferences +=
              ';prop => prop.' + column.reference;

          referenceExist.push(column.reference);
        }
			}
    });

    if (this.disableInit)
      return;

		if (!this.defaultFilter) this.getData();
	}

	setDefaultFilters(defaultFilters: IDefaultFilter[]): void {
		this.predicate = '';
		this.defaultFilterList = defaultFilters;

		this.setDefaultPredicate();
	}

	setDefaultPredicate(): void {
    this.defaultFilterList.forEach((element) => {
      let column: IColumn = this.columns.find(p => p.name == element.field);
      let reference: string = element.field;

      if (column.reference) {
        if (column.propertyInternalName)
          reference = column.reference + "." + column.propertyInternalName;
        else
          reference = column.name;
      }

			if (this.predicate.length == 0) {
				switch (element.type) {
          case ColumnTypeEnum.Number:
            this.predicate = 'p => p.' + reference + ' == ' +	Number(element.value);
						break;
          case ColumnTypeEnum.String:
            if (element.isOptional)
              this.predicate =  'p => p.' + reference + ' != null || p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
            else {
              if (element.isGroup)
                this.predicate = 'p => (p.' + reference + ' != null && p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
              else
                this.predicate = 'p => p.' + reference + ' != null && p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
            }
                
						break;
					case ColumnTypeEnum.Date:
						this.predicate =
              'p => p.' + reference + '.Date == System.Convert.ToDateTime("' + element.value + '").Date';
            break;
          case ColumnTypeEnum.DateNullable:
            this.predicate =
              'p => p.' + reference + '.Value.Date == System.Convert.ToDateTime("' + element.value + '").Date';
            break;
          case ColumnTypeEnum.DateGreaterThan:
            this.predicate =
              'p => p.' + reference + '.Date >= System.Convert.ToDateTime("' + element.value + '").Date';
            break;
          case ColumnTypeEnum.DateLessThan:
            this.predicate =
              'p => p.' + reference + '.Date <= System.Convert.ToDateTime("' + element.value + '").Date';
            break;
					case ColumnTypeEnum.Boolean:
            this.predicate = 'p=> p.' + reference + ' == ' + element.value;
						break;
					case ColumnTypeEnum.Time:
            this.predicate = `p => p.${reference}.CompareTo(System.TimeSpan.Parse("${ element.value }")) == ${0}`;
            break;
          case ColumnTypeEnum.Guid:
            this.predicate = 'p => p.' + reference + ' != null && p.' + reference + '.ToString().ToLower().Contains("' + element.value.toLowerCase() + '")';
            break;
				}
			} else {
				switch (element.type) {
					case ColumnTypeEnum.Number:
            this.predicate += ' && p.' + reference + ' == ' + element.value;
						break;
          case ColumnTypeEnum.String:
            if (element.isOptional) {
              if (element.isGroup)
                this.predicate += ' && p.' + reference + ' != null || p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '"))';
              else
                this.predicate += ' && p.' + reference + ' != null || p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
            }
            else {
              if (element.isGroup)
                this.predicate += ' && (p.' + reference + ' != null && p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
              else
                this.predicate += ' && p.' + reference + ' != null && p.' + reference + '.ToLower().Contains("' + element.value.toLowerCase() + '")';
            }
              
            
						break;
					case ColumnTypeEnum.Date:
            this.predicate += ' && p.' + reference + '.Date == System.Convert.ToDateTime("' +	element.value + '").Date';
            break;
          case ColumnTypeEnum.DateNullable:
            this.predicate += ' && p.' + reference + '.Value.Date == System.Convert.ToDateTime("' + element.value + '").Date';
            break;
          case ColumnTypeEnum.DateGreaterThan:
            this.predicate += ' && p.' + reference + '.Date >= System.Convert.ToDateTime("' + element.value + '").Date';
            break;
          case ColumnTypeEnum.DateLessThan:
            this.predicate += ' && p.' + reference + '.Date <= System.Convert.ToDateTime("' + element.value + '").Date';
            break;
					case ColumnTypeEnum.Boolean:
            this.predicate += ' && p.' + reference + ' == ' + element.value;
						break;
					case ColumnTypeEnum.Time:
            this.predicate += ` && p.${reference}.CompareTo(System.TimeSpan.Parse("${element.value}")) == ${0}`;
            break;
          case ColumnTypeEnum.Guid:
            this.predicate += ' && p.' + reference + ' != null && p.' + reference + '.ToString().ToLower().Contains("' + element.value.toLowerCase() + '")';
            break;
				}
			}
		});

		this.getData();
	}

	ngOnChanges(): void {
		if (this.pagedResult)
			this.myPaginationString =
				this.translateService.data.TABLE.SHOWING +
				this.pagedResult.firstRowOnPage +
				this.translateService.data.TABLE.TO +
				this.pagedResult.lastRowOnPage +
				this.translateService.data.TABLE.OF +
				this.pagedResult.rowCount +
				this.translateService.data.TABLE.RECORDS;
	}

	protected add(): void {
		this.buttonAdd.emit();
	}

  protected edit(): void {
    if (!this.hideButtonEdit) {
      if (this.selectedData == null || this.selectedData == undefined) {
        this.notificationService.error(this.translateService.data.TABLE.SELECT_ROW);

        return;
      }

      this.buttonEdit.emit(this.selectedData);
    }
	}

	getData(): void {
    this.loading = true;
    let projectedExpression: string = this.isProjected ? this.getProjectedExpresion() : null;

    this.jabilTableService.getByPagination(this.service, this.controller, this.endPoint, { pageNumber: this.pageNumber + 1, pageSize: this.pageSize, predicate: this.predicate, projected: projectedExpression, sort: this.sort, sortDirection: this.sortDirection, reference: this.propertyReferences }).subscribe(
      {
        next: (result: TransactionResult<IPagedResult>) => {
          this.loading = false;
          if (result.success) {
            this.table.sortOrder = 0;
            this.table.sortField = '';
            this.table.reset();
            this.pagedResult = result.data;
            this.data = this.pagedResult.results;
            this.rowCount = this.pagedResult.rowCount;
            this.pageCount = this.pagedResult.pageCount;

            this.myPaginationString =
              this.translateService.data.TABLE.SHOWING +
              this.pagedResult.firstRowOnPage +
              this.translateService.data.TABLE.TO +
              this.pagedResult.lastRowOnPage +
              this.translateService.data.TABLE.OF +
              this.pagedResult.rowCount +
              this.translateService.data.TABLE.RECORDS;

            this.onChangeData.emit(this.data);
          }
        },
        error: (error: any) => {
          this.loading = false;
        }
      }
    );
	}


  protected paginate(event: any): void {
		this.pageNumber = event.page;
		this.pageSize = event.rows;

		this.getData();
	}

	protected filterByColumn(): void {
		let filters: NodeListOf<HTMLInputElement> = <NodeListOf<HTMLInputElement>>document.getElementsByName('filterByColumn');

		this.predicate = '';

    filters.forEach((element) => {

      let caption: string = (<string>(<unknown>element.getAttribute('data-caption')));
      let column: IColumn = null;

      if (this.clickCheckBox && element.type == 'checkbox')
        column = this.columns.find(p => p.name == element.id.split('-')[0]);
      else
        column = this.columns.find(p => p.name == element.title && p.caption == caption);

      let reference: string = element.title;

      if (column) {
        if (column.reference) {
          if (column.propertyInternalName)
            reference = column.reference + "." + column.propertyInternalName;
          else
            reference = column.name;
        }
      }

			if (element.type == 'text') {
				if (element.value.length > 0) {
					let dataType: ColumnTypeEnum = <ColumnTypeEnum>((<Number>(<unknown>element.getAttribute('data-type'))));

					if (this.predicate.length == 0) {
						switch (Number(dataType)) {
							case ColumnTypeEnum.Number:
                this.predicate = 'p => p.' + reference + ' == ' +	Number(element.value);
								break;
							case ColumnTypeEnum.String:
                this.predicate = 'p => p.' + reference + ' != null && p.' + reference +	'.ToLower().Contains("' + element.value.toLowerCase() + '")'
                break;
              case ColumnTypeEnum.Guid:
                this.predicate = 'p => p.' + reference + ' != null && p.' + reference + '.ToString().ToLower().Contains("' + element.value.toLowerCase() + '")'
                break;
						}
					} else {
						switch (Number(dataType)) {
							case ColumnTypeEnum.Number:
                this.predicate += ' && p.' + reference +	' == ' + element.value;
								break;
							case ColumnTypeEnum.String:
                this.predicate += ' && p.' + reference + ' != null && p.' + reference +	'.ToLower().Contains("' +	element.value.toLowerCase() + '")';
                break;
              case ColumnTypeEnum.Guid:
                this.predicate += ' && p.' + reference + ' != null && p.' + reference + '.ToString().ToLower().Contains("' + element.value.toLowerCase() + '")';
                break;
						}
					}
				}
			}

			if (element.type == 'date') {
        if (element.value.length > 0) {
          let dataType: ColumnTypeEnum = <ColumnTypeEnum>((<Number>(<unknown>element.getAttribute('data-type'))));

          switch (Number(dataType)) {
            case ColumnTypeEnum.Date:
            case ColumnTypeEnum.DateGreaterThan:
            case ColumnTypeEnum.DateLessThan:
              if (this.predicate.length == 0)
                this.predicate = 'p => p.' + reference + '.Date == System.Convert.ToDateTime("' + element.value + '").Date';
              else
                this.predicate += ' && p.' + reference + '.Date == System.Convert.ToDateTime("' + element.value + '").Date';

              break;

            case ColumnTypeEnum.DateNullable:
              if (this.predicate.length == 0)
                this.predicate = 'p => p.' + reference + '.Value.Date == System.Convert.ToDateTime("' + element.value + '").Date';
              else
                this.predicate += ' && p.' + reference + '.Value.Date == System.Convert.ToDateTime("' + element.value + '").Date';

              break;
          }
        }
			}

			if (this.clickCheckBox) {
				if (element.type == 'checkbox') {
					if (this.predicate.length == 0)
						this.predicate = 'p=> p.' +	element.id.split('-')[0] + ' == ' + element.checked;
					else
						this.predicate +=	' && p.' + element.id.split('-')[0] + ' == ' + element.checked;
				}
			}

			if (element.type == 'time') {
				if (element.value.length > 0) {
					if (this.predicate.length == 0)
            this.predicate = `p => p.${reference}.CompareTo(System.TimeSpan.Parse("${element.value}")) == ${0}`;
					else
            this.predicate += ` && p.${reference}.CompareTo(System.TimeSpan.Parse("${element.value}")) == ${0}`;
				}
			}
		});

		if (this.predicate.length == 0) {
			this.predicate = 'p => true';

			this.clickCheckBox = false;
			this.clickDatePicker = false;
		}

		if (!this.defaultFilter) this.getData();
		else this.setDefaultPredicate();
	}

  protected filterData(): void {
    let column: IColumn = this.columns.find(p => p.name == this.formFilter.controls.order.value);
    if (column.reference && column.propertyInternalName)
      this.sort = 'order => order.' + column.reference + "." + column.propertyInternalName;
    else
      this.sort = 'order => order.' + this.formFilter.controls.order.value;

		this.sortDirection = this.formFilter.controls.orderType.value;

		this.getData();
	}

	protected export(): void {
    if (this.pagedResult) {
      let projectedExpression: string = this.isProjected ? this.getProjectedExpresion() : null;

			this.loading = true;
			this.jabilTableService
				.getByPagination(
					this.service,
					this.controller,
					this.endPoint,
					{ pageNumber: 1, pageSize: this.pagedResult.rowCount, predicate: this.predicate, projected: projectedExpression, sort: this.sort, sortDirection: this.sortDirection, reference: this.propertyReferences }
				)
				.subscribe(
          {
            next: (result: TransactionResult<IPagedResult>) => {
              this.loading = false;
              if (result.success) {
                this.exportExcel(result.data);
              }
            },
            error: (error: any) => {
              this.loading = false;
            }
          }
				);
		}
	}

	protected exportExcel(data: IPagedResult): void {
		import('xlsx').then((xlsx) => {
			let headers: Array<string> = [];
			let properties: Array<string> = [];

      this.columns.forEach((column) => {
        if (!column.hidden && column.type != ColumnTypeEnum.ImageByte) {
          headers.push(
            this.translateService.translateKey(column.translate),
          );
          properties.push(column.caption);
        }
			});

			var heading = [headers];

			var records = data.results.map((result) => {
				var object = {};

        this.columns.forEach((p) => {
          if (!p.hidden &&  p.type != ColumnTypeEnum.ImageByte)
            object[p.caption] = this.getValue(result, p);
				});

				return object;
			});

			const ws = xlsx.utils.book_new();
			const wb = xlsx.utils.json_to_sheet([]);

			xlsx.utils.sheet_add_aoa(wb, heading);
			xlsx.utils.sheet_add_json(wb, records, {
				origin: 'A2',
				skipHeader: true,
				header: properties,
			});
			xlsx.utils.book_append_sheet(ws, wb, this.title);
			xlsx.writeFile(ws, this.title + '.xlsx');
		});
	}

	protected clickCustomAction(data: any, actionName: string): void {
		let actionData: IActionCustomData = { data: data, name: actionName };
		this.customActionEvent.emit(actionData);
	}

  refresh(): void {
    this.paginator.changePage(0);
    this.sort = 'order => order.';
    this.sortDirection = 'Ascending';
    this.predicate = 'p => true';
    this.pageNumber = 0;
    this.pageCount = 0;
    this.pageSize = 10;
    this.table.reset();
    this.clickCheckBox = false;
    this.clickDatePicker = false;
    this.indeterminate = true;
    this.rowCount = 0;
    this.propertyReferences = "";


		let filters: NodeListOf<HTMLInputElement> = <
			NodeListOf<HTMLInputElement>
		>document.getElementsByName('filterByColumn');
		filters.forEach((element) => {
			if (
				element.type == 'text' ||
				element.type == 'date' ||
				element.type == 'time'
			) {
				element.value = '';
			}
		});

    setTimeout(() => {
      if (this.defaultFilter) this.setDefaultPredicate();
      else this.setInitial();
    }, 1000);
  }

  protected getProjectedExpresion(): string {
    if (this.columns) {
      let projected: string = "projected => new {";

      this.columns.forEach((column: IColumn) => {
        if (column.reference) {
          if (column.propertyInternalName)
            projected += column.name + " = projected." + column.reference + "." + column.propertyInternalName + ",";
          else
            projected += column.name + " = projected." + column.reference + "." + column.name + ",";
        }
        else
          projected += column.name + " = projected." + column.name + ",";
      });

      projected = projected.substring(0, projected.length - 1);
      projected += " }";

      return projected;

    }

    return "";
  }

  protected getValue(data: any, column: IColumn): object {
    let fields: Array<string> = column.caption.split(".");

    if (fields.length == 1)
      return data[fields[0]];
    else {
      let value: any = JSON.parse(JSON.stringify(data));

      fields.forEach(field => {
        value = value != null ? value[field] : "";
      });

      return value;
    }
  }

  protected SetChecket(data: any, column: IColumn): void {
    this.isChecked = JSON.parse(JSON.stringify(this.getValue(data, column)));
  }
}
